'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:InvoiceNewCtrl
 * @description
 * # InvoiceNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('InvoiceNewCtrl', [
  '$scope', '$state', '$stateParams', '$rootScope', 'Invoice',
  function ($scope, $state, $stateParams, $rootScope, Invoice) {
      $scope.projectId = $stateParams.projectId;
      if($stateParams.invoiceId) {
        Invoice.find($stateParams.invoiceId).then(function(response) {
          $scope.invoiceHash = { 'invoice': response.data.invoice };
          $scope.invoiceHash.invoice.date_of_invoice = new Date(response.data.invoice.date_of_invoice);
          $scope.invoiceHash.invoice.percentage_value = Number(response.data.invoice.percentage_value);
          if($scope.invoiceHash.invoice.state == "Resuelto") {
            $scope.editableFolio = true;
          }
          delete $scope.invoiceHash.invoice.state;
        }, function(error) {
          Invoice.error(error);
        });
      } else {
        $scope.invoiceHash = {
          'invoice': {
            'date_of_invoice': new Date(),
            'percentage_value': 1,
            'audit_comment': '',
            'project_id': $stateParams.projectId
          }
        };
      }

      // traer el missing percentage
      Invoice.findMissingPercentage($scope.projectId).then((response) => {
        $scope.missingPercentage = response.data.missing_percentage
      }).catch((err) => {
        Invoice.error(err)
      });

      $scope.saveInvoice = function() {
        Invoice.save($scope.invoiceHash).then(function(response) {
          $state.go('app.projects.show', { projectId: $stateParams.projectId })
        }, function(error) {
          Invoice.error(error);
        });
      };
  }]);
